import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import PortalPage from './pages/PortalPage';

function AppInner() {
  const { user, loading } = useAuth();

  if (loading) return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#f0ede8', fontFamily: 'Georgia, serif', fontSize: 18, color: '#aaa'
    }}>
      Laden...
    </div>
  );

  if (!user) return <LoginPage />;
  return <PortalPage />;
}

export default function App() {
  return (
    <AuthProvider>
      <AppInner />
    </AuthProvider>
  );
}
